import * as React from 'react'

function SvgZoom(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={'icon icon--zoom ' + (props.classes ? props.classes : '')}
      {...props}
    >
      <defs>
        <path
          id="24-zoom_svg__a"
          d="M13 10h-1V9c0-.55-.45-1-1-1s-1 .45-1 1v1H9c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1m-8 1c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6m15.707 8.293l-3.395-3.396A7.952 7.952 0 0019 11c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8a7.952 7.952 0 004.897-1.688l3.396 3.395a.997.997 0 001.414 0 .999.999 0 000-1.414"
        />
      </defs>
      <use xlinkHref="#24-zoom_svg__a" fillRule="evenodd" />
    </svg>
  )
}

export default SvgZoom
